module.exports = __webpack_public_path__ + "img/line-sm.8ca956a2.svg";